/*
 * Nine Fives light/dark mode.
 *
 * layout/theme.liquid runs a tiny inline script before the first stylesheet
 * that sets <html data-nf-color-mode="light|dark"> from localStorage, the
 * theme setting default, or the OS preference, so there is no flash. This
 * file keeps that attribute in sync with OS changes and powers the
 * <nf-color-mode-toggle> button rendered by snippets/color-mode-toggle.liquid.
 *
 * Other scripts can listen for `nf:color-mode` on document to react to a
 * switch (detail.mode is 'light' or 'dark').
 */
(function () {
  const STORAGE_KEY = 'nf-color-mode';
  const root = document.documentElement;
  const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: light)') : null;
  const defaultMode = root.getAttribute('data-nf-color-mode-default') || 'system';

  const storedMode = () => {
    try {
      const value = localStorage.getItem(STORAGE_KEY);
      return value === 'light' || value === 'dark' ? value : null;
    } catch (error) {
      return null;
    }
  };

  const systemMode = () => (media && media.matches ? 'light' : 'dark');

  const resolveMode = () => storedMode() || (defaultMode === 'system' ? systemMode() : defaultMode);

  const applyMode = (mode) => {
    root.setAttribute('data-nf-color-mode', mode);
    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) {
      const color = themeColor.getAttribute(mode === 'light' ? 'data-nf-light' : 'data-nf-dark');
      if (color) themeColor.setAttribute('content', color);
    }
    document.querySelectorAll('nf-color-mode-toggle').forEach((toggle) => toggle.sync(mode));
    document.dispatchEvent(new CustomEvent('nf:color-mode', { detail: { mode } }));
  };

  if (media) {
    // Follow the OS while the visitor has not chosen explicitly.
    media.addEventListener('change', () => {
      if (!storedMode()) applyMode(resolveMode());
    });
  }

  class ColorModeToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', () => {
        const next = root.getAttribute('data-nf-color-mode') === 'light' ? 'dark' : 'light';
        try {
          localStorage.setItem(STORAGE_KEY, next);
        } catch (error) {
          /* private mode: the choice lasts for this page view only */
        }
        applyMode(next);
      });
      this.sync(root.getAttribute('data-nf-color-mode') || resolveMode());
    }

    sync(mode) {
      if (!this.button) return;
      // The label names the action, i.e. the mode the button switches to.
      const label = mode === 'light' ? this.dataset.labelDark : this.dataset.labelLight;
      if (label) {
        this.button.setAttribute('aria-label', label);
        this.button.setAttribute('title', label);
      }
    }
  }

  if (!customElements.get('nf-color-mode-toggle')) {
    customElements.define('nf-color-mode-toggle', ColorModeToggle);
  }

  applyMode(resolveMode());
})();
